<div class="skeleton-card">
    <div class="skeleton-image"></div>
    <div class="skeleton-details">
      <div class="skeleton-title"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-vin"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
      <div class="skeleton-info"></div>
    </div>
  </div>
  